// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9a3fa53d","732":"d0af3d3b","977":"5e8982fd"}[chunkId] + ".chunk.js";
};